let _draft = null;

export const saveDraft = (data) => {
  try {
    _draft = JSON.parse(JSON.stringify(data, (_k, v) =>
      v instanceof File || v instanceof FileList ? undefined : v
    ));
  } catch {}
};

export const popDraft = () => {
  const d = _draft;
  _draft = null;
  return d;
};
